import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { SiteProvider } from "./context/SiteContext";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import AuthCallback from "./components/AuthCallback";
import ScrollToTop from "./components/ScrollToTop";

import Home from "./pages/Home";
import Services from "./pages/Services";
import Courses from "./pages/Courses";
import CourseDetail from "./pages/CourseDetail";
import Portfolio from "./pages/Portfolio";
import Resources from "./pages/Resources";
import About from "./pages/About";
import Pricing from "./pages/Pricing";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Dashboard from "./pages/Dashboard";
import Admin from "./pages/Admin";
import Learn from "./pages/Learn";
import Certificate from "./pages/Certificate";
import Launch from "./pages/Launch";
import Blueprint from "./pages/Blueprint";
import BlueprintLanding from "./pages/BlueprintLanding";
import BlueprintReader from "./pages/BlueprintReader";
import CourseOffer from "./pages/CourseOffer";
import BhajanLanding from "./pages/BhajanLanding";
import BhajanThankYou from "./pages/BhajanThankYou";
import MagicLogin from "./pages/MagicLogin";
import Privacy from "./pages/Privacy";

const page = (el) => <Layout>{el}</Layout>;

function AppRouter() {
    const location = useLocation();
    if (location.hash?.includes("session_id=")) return <AuthCallback />;
    return (
        <Routes>
            <Route path="/" element={page(<Home />)} />
            <Route path="/services" element={page(<Services />)} />
            <Route path="/courses" element={page(<Courses />)} />
            <Route path="/academy" element={page(<Courses />)} />
            <Route path="/courses/:slug" element={page(<CourseDetail />)} />
            <Route path="/portfolio" element={page(<Portfolio />)} />
            <Route path="/work" element={page(<Portfolio />)} />
            <Route path="/resources" element={page(<Resources />)} />
            <Route path="/about" element={page(<About />)} />
            <Route path="/pricing" element={page(<Pricing />)} />
            <Route path="/blog" element={page(<Blog />)} />
            <Route path="/blog/:slug" element={page(<BlogDetail />)} />
            <Route path="/privacy" element={page(<Privacy />)} />
            <Route path="/legal" element={page(<Privacy />)} />
            <Route path="/launch" element={page(<Launch />)} />
            <Route path="/blueprint" element={<BlueprintLanding />} />
            <Route path="/bhajans" element={<BhajanLanding />} />
            <Route path="/bhajans/thank-you" element={<BhajanThankYou />} />
            <Route path="/bhajan" element={<BhajanLanding />} />
            <Route path="/blueprint/read" element={<BlueprintReader />} />
            <Route path="/blueprint/course" element={<CourseOffer />} />
            <Route path="/video-course" element={<CourseOffer />} />
            <Route path="/blueprint-legacy" element={page(<Blueprint />)} />
            <Route path="/login" element={<Login />} />
            <Route path="/auth/magic" element={<MagicLogin />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/learn/:slug" element={<ProtectedRoute><Learn /></ProtectedRoute>} />
            <Route path="/certificate/:slug" element={<ProtectedRoute><Certificate /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
        </Routes>
    );
}

export default function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <SiteProvider>
                    <ScrollToTop />
                    <AppRouter />
                    <Toaster position="top-center" />
                </SiteProvider>
            </BrowserRouter>
        </AuthProvider>
    );
}
